class e extends Error {
  constructor(r = "") {
    super(r), this.name = this.constructor.name;
  }
}
export {
  e as MaintenanceError
};
